import React, { Fragment, useContext, useEffect, useState } from 'react';
import { ActionButton, Button, DocumentCard, DocumentCardActions, DocumentCardActivity, DocumentCardLocation, DocumentCardPreview, DocumentCardTitle, Dropdown, IDropdownOption, Icon, IconButton, PrimaryButton, Text, Toggle, TooltipHost } from "office-ui-fabric-react";
import { ulid } from 'ulid';




import { WsAppContext } from "../../AppContext";

import { NavLink, Route, Switch, useHistory, useLocation, useParams } from "react-router-dom";

import { apiGet, apiPost } from "../../../helpers-sales";

import { WsDeliverTenantInterface } from "../../../../../core/src/interfaces";

import { WsConfigDataType } from "./ConfigPage";

import { WsConfigHistory } from "../Config/ConfigHistory";

import { getTenantStatus, getWorkloads, WsWorkloadItem } from "../data/deliver-data";
import { Loading } from "../../Shared";

import { WsDeliverTenantStatus } from "../../../enums";

import { WsDeliverPortalContext } from "../DeliverPortalContext";
import { wait } from "../../../helpers";





import './ConfigPage.scss';
import './ConfigTenant.scss';
import { WsDeliverTenantAction, WsTenantActionButton } from "./TenantActionButton";
import { WsTenantActionDialog } from "./TenantActionDialog";







const WsTenantDetails = (props: {
  loadData: () => Promise<void>;
  tenants: WsDeliverTenantInterface[];
  tenant: WsDeliverTenantInterface
}) => {

  const [ tenantActionDialogVisible, setTenantActionDialogVisible ] = useState<WsDeliverTenantAction | undefined>(undefined);

  const history = useHistory();

  const params: { tenantType: string, tenantId: string } = useParams();

  return (
    <>
      <div className="ws-deliver-tenant-details">
        <div className="columns">
          <div className="column is-2">Tenant Name:</div>
          <div className="column is-4"><b>{props.tenant.name}</b></div>
          <div className="column is-3">Status:</div>
          <div className="column">

            <WsTenantStatus tenant={props.tenant} statusField="Status" showLabel={true} />

            {/* {
              (!props.tenant.fields.error && !props.tenant.fields.sync)
              &&
              <>
                <Icon className="ws-deliver-tenant-ok" iconName={'SkypeCircleCheck'} /> OK
              </>
            } */}

            {/* {
              props.tenant.fields.error
              &&
              <>
                <Icon className="ws-deliver-tenant-not-ok" iconName={'Error'} /> Sync Failed
              </>
            } */}

            {/* {
              props.tenant.fields.sync
              &&
              <>
                <Icon className="ws-deliver-tenant-sync" iconName={'SyncStatus'} /> Syncing...
              </>
            } */}

          </div>
        </div>
        <div className="columns">
          <div className="column is-2">Tenant ID:</div>
          <div className="column is-4">{props.tenant.azureTenantId}</div>
          <div className="column is-3">
            Sync:

            <IconButton className="ws-deliver-refresh" iconProps={{iconName: 'FullHistory' }} title="Sync History" onClick={async () => {
              history.push(`/deliver/config/${params.tenantType}/${params.tenantId}/history`);
            }} />

            {
              getTenantStatus(props.tenant, 'SyncStatus') === WsDeliverTenantStatus.Ready
              ?
              <IconButton className="ws-deliver-refresh" iconProps={{ iconName: 'BoxPlaySolid' }} title="Start Sync" onClick={async () => {

                const config = await apiPost(`/deliver/tenants/${props.tenant.azureTenantId}/action`, { action: 'SYNC' });
  
                if (config && config.deliverTenant) {
                  await props.loadData();
                }
              }} />
              :
              <IconButton className="ws-deliver-refresh" iconProps={{iconName: 'CircleStopSolid' }} title="Stop Sync" onClick={async () => {
                
                const config = await apiPost(`/deliver/tenants/${props.tenant.azureTenantId}/action`, { action: 'STOP' });

                if (config && config.deliverTenant) {
                  await props.loadData();
                }
              }} />
            }
          </div>
          <div className="column">
            <WsTenantStatus tenant={props.tenant} statusField="SyncStatus" showLabel={true} />
          </div>
        </div>
        <div className="columns">
          <div className="column is-2">Tenant Owner:</div>
          <div className="column is-4">Daniel Ames</div>
          <div className="column is-3">
            Backup:

            <IconButton className="ws-deliver-refresh" iconProps={{iconName: 'FullHistory' }} title="Backup History" onClick={async () => {
              history.push(`/deliver/config/${params.tenantType}/${params.tenantId}/backup-history`);
            }} />

            {
              getTenantStatus(props.tenant, 'BackupStatus') === WsDeliverTenantStatus.Ready
              ?
              <IconButton className="ws-deliver-refresh" iconProps={{ iconName: 'BoxPlaySolid' }} title="Start Backup" onClick={async () => {

                const config = await apiPost(`/deliver/tenants/${props.tenant.azureTenantId}/action`, { action: 'BACKUP' });
  
                if (config && config.deliverTenant) {
                  await props.loadData();
                }
              }} />
              :
              <IconButton className="ws-deliver-refresh" iconProps={{iconName: 'CircleStopSolid' }} title="Stop Backup" onClick={async () => {
                
                const config = await apiPost(`/deliver/tenants/${props.tenant.azureTenantId}/action`, { action: 'STOP' });

                if (config && config.deliverTenant) {
                  await props.loadData();
                }
              }} />
            }
          </div>
          <div className="column">
            <WsTenantStatus tenant={props.tenant} statusField="BackupStatus" showLabel={true} />
          </div>
        </div>
        <div className="columns">
          <div className="column is-2"></div>
          <div className="column is-4"></div>
          <div className="column is-3">Tenant Actions:</div>
          <div className="column"><div style={{ marginTop: '-4px' }}><WsTenantActionButton loadData={props.loadData} tenantType={params.tenantType} tenantId={props.tenant.azureTenantId} tenant={props.tenant} setTenantActionDialogVisible={setTenantActionDialogVisible} /></div></div>
        </div>
      </div>
      {
        tenantActionDialogVisible
        &&
        <WsTenantActionDialog
          tenants={props.tenants}
          action={tenantActionDialogVisible}
          hideDialog={() => {
            setTenantActionDialogVisible(undefined);
          }}
        />
      }
    </>
  ); 
};




const WsConfigTenant = (props: {}) => {

  const portalContext = useContext(WsDeliverPortalContext);

  const currentLocation = useLocation();

  const history = useHistory();

  const params: { tenantType: string, tenantId: string, compareTenantId?: string, snapshotId?: string, workloads?: string, workload?: string } = useParams();

  const [ applicationId, setApplicationId ] = useState<string>('entraid');

  const [ tenants, setTenants ] = useState<WsDeliverTenantInterface[] | undefined>(undefined);


  

  const paramsAction = useParams();

  const [ processRunning, setProcessRunning ] = useState<string>('');

  const [ dataType, setDataType ] = useState<string>('dsc');

  const [ emptyFieldsVisible, setEmptyFieldsVisible ] = useState<boolean>(true);



  const loadData = async () => {

    setTenants(undefined);

    const result = await apiGet(`/deliver/tenants`);

    if (result && Array.isArray(result.deliverTenants)) {
      const resultData = result.deliverTenants as WsDeliverTenantInterface[];
      console.log(resultData);
      setTenants(resultData);
    }
  };



  useEffect(() => {
    loadData();
  }, []);



  const startDscProcess = async (action: string) => {

    console.log(`JOB : ${action}`);

    const trace = `ws-trace-${ulid().toLowerCase()}`;

    portalContext?.showBackgroundJob({
      text: action === 'RESTORE' ? 'Restore Tenant Configuration' : 'Clone Tenant Configuration',
      text2: 'Starting...',
      url: '',
      id: trace,
      progress: 0.1,
      jobId: 0,
      updateOrCreate: false
    });

    const payload = {
      trace,
      ownerEmail: portalContext?.currentUser?.email,
      action,
      sourceAzureTenantId: params.compareTenantId ? params.compareTenantId : params.tenantId
    };

    if (params.snapshotId) {
      payload['sourceSnapshotId'] = params.snapshotId;
    }

    if (params.workloads) {
      payload['workloads'] = params.workloads;
    }

    const config = await apiPost(`/deliver/tenants/${params.tenantId}/action`, payload);

  };



  if (tenants) {

    console.log(paramsAction);

    const tenant = tenants.find((t) => t.azureTenantId === params.tenantId);

    const compareTenant = tenants.find((t) => t.azureTenantId === params.compareTenantId);

    if (tenant) {

      // console.log(params);

      return (
        <div className="ws-deliver-config-application-page">

          <WsTenantDetails loadData={loadData} tenants={tenants} tenant={tenant} />

          <div className="ws-deliver-config-header">

            <Text key={'ws-sales-clients'} variant={'xLarge'} nowrap block>

              <Route path={`/deliver/config/:tenantType/:tenantId/history`}>
                Sync History
              </Route>

              <Route path={`/deliver/config/:tenantType/:tenantId/backup-history`}>
                Backup History
              </Route>

              <Route path={`/deliver/config/:tenantType/:tenantId/restore/:snapshotId/:workloads`}>
                Restore Backup
                {
                  !processRunning
                  &&
                  <>
                    <WsConfigDataType
                      page="configuration"
                      emptyFieldsVisible={emptyFieldsVisible}
                      setEmptyFieldsVisible={setEmptyFieldsVisible}
                      dataType={dataType}
                      setDataType={setDataType}
                    />
                    <div style={{
                      position: 'absolute',
                      top: '1px',
                      right: '1px'
                    }}>
                      <PrimaryButton
                        onClick={async () => {
                          await startDscProcess('RESTORE');
                        }}
                      >
                        Start Tenant Restore
                      </PrimaryButton>
                    </div>
                  </>
                }
              </Route>

              <Route path={`/deliver/config/:tenantType/:tenantId/clone/:compareTenantId/:workloads`}>
                Clone Tenant
                {
                  !processRunning
                  &&
                  <>
                    <WsConfigDataType
                      page="configuration"
                      emptyFieldsVisible={emptyFieldsVisible}
                      setEmptyFieldsVisible={setEmptyFieldsVisible}
                      dataType={dataType}
                      setDataType={setDataType}
                    />
                    <div style={{
                      position: 'absolute',
                      top: '1px',
                      right: '1px'
                    }}>
                      <PrimaryButton
                        onClick={async () => {
                          await startDscProcess('CLONE');
                        }}
                      >
                        Start Tenant Clone
                      </PrimaryButton>
                    </div>
                  </>
                }
              </Route>

              <Route path={`/deliver/config/:tenantType/:tenantId/compare/:compareTenantId`}>
                Compare Tenants
                <WsConfigDataType
                  page="configuration"
                  emptyFieldsVisible={emptyFieldsVisible}
                  setEmptyFieldsVisible={setEmptyFieldsVisible}
                  dataType={dataType}
                  setDataType={setDataType}
                />
              </Route>

              <Route path={`/deliver/config/:tenantType/:tenantId/current/:workload`}>
                Current Configuration
                <WsConfigDataType
                  page="configuration"
                  emptyFieldsVisible={emptyFieldsVisible}
                  setEmptyFieldsVisible={setEmptyFieldsVisible}
                  dataType={dataType}
                  setDataType={setDataType}
                />
              </Route>

              <Route path={`/deliver/config/:tenantType/:tenantId`} exact>
                Enabled Workloads
              </Route>
            </Text>

            {/* <div className="ws-deliver-config-header-options">
            </div> */}

            {
              (
                currentLocation.pathname.indexOf('/current/') > -1
                ||
                currentLocation.pathname.indexOf('/compare/') > -1
              )
              &&
              <div className="ws-deliver-config-header-options ws-deliver-config-header-options-right">

                <Dropdown
                  // label={props.label}
                  options={[
                    // { key: 'access',        text: 'Microsoft Access' },
                    { key: 'entraid',            text: 'Microsoft Entra ID'       },
                    { key: 'exchange',           text: 'Microsoft Exchange'       },
                    { key: 'intune',             text: 'Microsoft Intune'         },
                    { key: 'onedrive',           text: 'Microsoft OneDrive'       },
                    { key: 'planner',            text: 'Microsoft Planner'        },
                    { key: 'powerplatform',      text: 'Microsoft Power Platform' },
                    { key: 'sharepoint',         text: 'Microsoft SharePoint'     },
                    { key: 'teams',              text: 'Microsoft Teams'          },
                    { key: 'office365',          text: 'Office 365'               },
                    { key: 'securitycompliance', text: 'Security & Compliance'    },
                    // { key: 'onenote',        text: 'OneNote'},
                  ]}
                  onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
                    if (option) {
                      if (params.workload) {
                        history.push(`/deliver/config/${params.tenantType}/${params.tenantId}/current/${option.key}`);
                      } else {
                        setApplicationId(`${option.key}`);
                      }
                    }
                  }}
                  selectedKey={params.workload ? params.workload : applicationId}
                />

              </div>
            }

          </div>

          {
            processRunning
            ?
            <Loading />
            :
            <>
              <Switch>

                <Route path={`/deliver/config/:tenantType/:tenantId/history`}>
                  <WsConfigHistory tenant={tenant} workload={params.workload ? params.workload : applicationId} dataType={dataType} showValues={true} showHistory={true} />
                </Route>

                <Route path={`/deliver/config/:tenantType/:tenantId/backup-history`}>
                  <Loading/>
                  {/* <table className="table is-bordered is-hoverable is-fullwidth ws-configuration-list ws-deliver-tenant-workloads">
                    <tbody>
                      <tr>
                        <td>Backup 11:42:05, 30/07/2024</td>
                      </tr>
                    </tbody>
                  </table> */}
                </Route>

                <Route path={`/deliver/config/:tenantType/:tenantId/restore/:snapshotId/:workloads`}>
                  <WsDeliverRestoreTenant
                    tenants={tenants}
                    workloadComponents={{
                      'entraid':    <WsConfigHistory tenant={tenant} workload={'entraid'}    dataType={dataType} showValues={true} compareTenant={tenants.find((t) => t.azureTenantId === '01903a3d-9408-7684-8552-c2258b002acb')} compareTenantName="Backup" />,
                      'exchange':   <WsConfigHistory tenant={tenant} workload={'exchange'}   dataType={dataType} showValues={true} compareTenant={tenants.find((t) => t.azureTenantId === '01903a3d-9408-7684-8552-c2258b002acb')} compareTenantName="Backup" />,
                      'intune':     <WsConfigHistory tenant={tenant} workload={'intune'}     dataType={dataType} showValues={true} compareTenant={tenants.find((t) => t.azureTenantId === '01903a3d-9408-7684-8552-c2258b002acb')} compareTenantName="Backup" />,
                      'sharepoint': <WsConfigHistory tenant={tenant} workload={'sharepoint'} dataType={dataType} showValues={true} compareTenant={tenants.find((t) => t.azureTenantId === '01903a3d-9408-7684-8552-c2258b002acb')} compareTenantName="Backup" />,
                      'teams':      <WsConfigHistory tenant={tenant} workload={'teams'}      dataType={dataType} showValues={true} compareTenant={tenants.find((t) => t.azureTenantId === '01903a3d-9408-7684-8552-c2258b002acb')} compareTenantName="Backup" />,
                      'onedrive':   <WsConfigHistory tenant={tenant} workload={'onedrive'}   dataType={dataType} showValues={true} compareTenant={tenants.find((t) => t.azureTenantId === '01903a3d-9408-7684-8552-c2258b002acb')} compareTenantName="Backup" />,
                    }}
                  />
                </Route>

                <Route path={`/deliver/config/:tenantType/:tenantId/clone/:compareTenantId/:workloads`}>
                  <WsDeliverRestoreTenant
                    tenants={tenants}
                    workloadComponents={{
                      'entraid':    <WsConfigHistory tenant={tenant} workload={'entraid'}    dataType={dataType} showValues={true} compareTenant={tenants.find((t) => t.azureTenantId === '01903a3d-9408-7684-8552-c2258b002acb')} compareTenantName={compareTenant?.name} />,
                      'exchange':   <WsConfigHistory tenant={tenant} workload={'exchange'}   dataType={dataType} showValues={true} compareTenant={tenants.find((t) => t.azureTenantId === '01903a3d-9408-7684-8552-c2258b002acb')} compareTenantName={compareTenant?.name} />,
                      'intune':     <WsConfigHistory tenant={tenant} workload={'intune'}     dataType={dataType} showValues={true} compareTenant={tenants.find((t) => t.azureTenantId === '01903a3d-9408-7684-8552-c2258b002acb')} compareTenantName={compareTenant?.name} />,
                      'sharepoint': <WsConfigHistory tenant={tenant} workload={'sharepoint'} dataType={dataType} showValues={true} compareTenant={tenants.find((t) => t.azureTenantId === '01903a3d-9408-7684-8552-c2258b002acb')} compareTenantName={compareTenant?.name} />,
                      'teams':      <WsConfigHistory tenant={tenant} workload={'teams'}      dataType={dataType} showValues={true} compareTenant={tenants.find((t) => t.azureTenantId === '01903a3d-9408-7684-8552-c2258b002acb')} compareTenantName={compareTenant?.name} />,
                      'onedrive':   <WsConfigHistory tenant={tenant} workload={'onedrive'}   dataType={dataType} showValues={true} compareTenant={tenants.find((t) => t.azureTenantId === '01903a3d-9408-7684-8552-c2258b002acb')} compareTenantName={compareTenant?.name} />,
                    }}
                  />
                </Route>

                <Route path={`/deliver/config/:tenantType/:tenantId/compare/:compareTenantId`}>
                  <WsConfigHistory tenant={tenant} workload={params.workload ? params.workload : applicationId} dataType={dataType} showValues={true} compareTenant={tenants.find((t) => t.azureTenantId === params.compareTenantId)} />
                </Route>

                <Route path={`/deliver/config/:tenantType/:tenantId/current/:workload`}>
                  <WsConfigHistory tenant={tenant} workload={params.workload ? params.workload : applicationId} dataType={dataType} showValues={true} />
                </Route>

                <Route path={`/deliver/config/:tenantType/:tenantId`} exact>
                  <table className="table is-bordered is-hoverable is-fullwidth ws-configuration-list ws-deliver-tenant-workloads">
                    <thead>
                      <tr>
                        <th></th>
                        <th></th>
                        <th>Sync</th>
                        <th>Backup</th>
                        <th>Discovery</th>
                        <th>Compliance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        getWorkloads().map((workloadItem, workloadIndex: number) => {
                          return (
                            <tr key={`ws-workload-${workloadIndex}`}>
                              <td>
                                {
                                  workloadItem.enabled
                                  ?
                                  <NavLink to={`/deliver/config/${params.tenantType}/${params.tenantId}/current/${workloadItem.id}`}>{workloadItem.name}</NavLink>
                                  :
                                  <>{workloadItem.name}</>
                                }
                              </td>
                              <td className={ workloadItem.enabled ? 'ws-workload-green' : 'ws-workload-red' }>{ workloadItem.enabled ? 'Enabled'  : 'Disabled' }</td>
                              <td className={ workloadItem.sync ? 'ws-workload-green' : 'ws-workload-yellow' }>{ getStatusName(workloadItem, 'sync') }</td>
                              <td className={ workloadItem.backup ? 'ws-workload-green' : 'ws-workload-yellow' }>{ getStatusName(workloadItem, 'backup') }</td>
                              <td className={ workloadItem.discovery ? 'ws-workload-green' : 'ws-workload-yellow' }>{ getStatusName(workloadItem, 'discovery') }</td>
                              <td className={ getComplianceCssClass(workloadItem) }>{ getStatusName(workloadItem, 'compliance') }</td>
                            </tr>
                          );
                        })
                      }
                    </tbody>
                  </table>
                </Route>

              </Switch>
              </>
            }
        </div>
      );

    } else {

      return (
        <div className="ws-deliver-config-application-page">
          Tenant not found!
        </div>
      );
    }

  } else {
    return (
      <Loading />
    )
  }
};


const getStatusName = (workloadItem: WsWorkloadItem, statusField: string) => {

  const s1 = {
    sync:       'Complete',
    backup:     'Complete',
    discovery:  'Complete',
    compliance: 'Compliant'
  };

  const s2 = {
    sync:       'In Progress',
    backup:     'In Progress',
    discovery:  'In Progress',
    compliance: 'Unknown'
  };

  const s3 = {
    sync:       'Incomplete',
    backup:     'Incomplete',
    discovery:  'Incomplete',
    compliance: 'Non-Compliant'
  };

  if (workloadItem.enabled) {
    if (workloadItem[statusField]) {
      return s1[statusField];
    } else {
      return s2[statusField];
    }
  } else {
    return s3[statusField];
  }
};



const getStatusClass = (workloadItem: WsWorkloadItem, statusField: string) => {
  if (workloadItem.enabled) {
    if (workloadItem[statusField]) {
      return 'Complete';
    } else {
      return 'In Progress';
    }
  } else {
    return 'Disabled';
  }
};





const getComplianceCssClass = (workloadItem: WsWorkloadItem) => {

  if (workloadItem.enabled) {

    if (workloadItem.compliance) {
      return 'ws-workload-green';

    } else {
      return 'ws-workload-yellow';
    }

  } else {
    return 'ws-workload-yellow';
  }
};




export const WsTenantStatus = (props: { tenant: WsDeliverTenantInterface; statusField: string, showLabel?: boolean }) => {

  const status = getTenantStatus(props.tenant, props.statusField);

  if (status === WsDeliverTenantStatus.InProgress) {

    return (
      <>
        <TooltipHost
          // directionalHint={DirectionalHint.bottomCenter}
          content={'In Progress...'}
          id={`ws-deliver-tenant-sync-tooltip-${props.tenant.azureTenantId}`}
          className="ws-deliver-tenant-sync-tooltip"
          calloutProps={{
            className: 'ws-deliver-tenant-sync-tooltip-callout',
            style: {
              // width: '200px'
            }
          }}
        >
          <Icon
            className="ws-deliver-tenant-sync"
            iconName={'SyncStatus'}
            aria-describedby={`ws-deliver-tenant-sync-tooltip-${props.tenant.azureTenantId}`}
          /> { props.showLabel && 'In Progress...' }
        </TooltipHost>
      </>
    );

  } else if (status === WsDeliverTenantStatus.SyncInProgress) {

      return (
        <>
          <TooltipHost
            // directionalHint={DirectionalHint.bottomCenter}
            content={'Sync in progress...'}
            id={`ws-deliver-tenant-sync-tooltip-${props.tenant.azureTenantId}`}
            className="ws-deliver-tenant-sync-tooltip"
            calloutProps={{
              className: 'ws-deliver-tenant-sync-tooltip-callout',
              style: {
                // width: '200px'
              }
            }}
          >
            <Icon
              className="ws-deliver-tenant-sync"
              iconName={'SyncStatus'}
              aria-describedby={`ws-deliver-tenant-sync-tooltip-${props.tenant.azureTenantId}`}
            /> { props.showLabel && 'Sync in progress...' }
          </TooltipHost>
        </>
      );

    } else if (status === WsDeliverTenantStatus.BackupInProgress) {

      return (
        <>
          <TooltipHost
            // directionalHint={DirectionalHint.bottomCenter}
            content={'Backup in progress...'}
            id={`ws-deliver-tenant-sync-tooltip-${props.tenant.azureTenantId}`}
            className="ws-deliver-tenant-sync-tooltip"
            calloutProps={{
              className: 'ws-deliver-tenant-sync-tooltip-callout',
              style: {
                // width: '200px'
              }
            }}
          >
            <Icon
              className="ws-deliver-tenant-sync"
              iconName={'SyncStatus'}
              aria-describedby={`ws-deliver-tenant-sync-tooltip-${props.tenant.azureTenantId}`}
            /> { props.showLabel && 'Backup in progress...' }
          </TooltipHost>
        </>
      );

  } else if (status === WsDeliverTenantStatus.Failed) {

    return (
      <>
        <TooltipHost
          // directionalHint={DirectionalHint.bottomCenter}
          content={'Failed!'}
          id={`ws-deliver-tenant-sync-tooltip-${props.tenant.azureTenantId}`}
          className="ws-deliver-tenant-sync-tooltip"
          calloutProps={{
            className: 'ws-deliver-tenant-sync-tooltip-callout',
            style: {
              // width: '200px'
            }
          }}
        >
          <Icon
            className="ws-deliver-tenant-not-ok"
            iconName={'Error'}
            aria-describedby={`ws-deliver-tenant-sync-tooltip-${props.tenant.azureTenantId}`}
          /> { props.showLabel && 'Failed!' }
        </TooltipHost>
      </>
    );

  } else {

    return (
      <>
        <Icon className="ws-deliver-tenant-ok" iconName={'SkypeCircleCheck'}  /> { props.showLabel && 'Ready' }
      </>
    );
  }
};




export const WsDeliverRestoreTenant = (props: {
  tenants: WsDeliverTenantInterface[];
  workloadComponents: { [ key: string ]: JSX.Element };
}) => {

  const params: { tenantType: string, tenantId: string, workloads: string } = useParams();

  const [ expandedIds, setSetExpandedIds ] = useState<string[]>([]);

  const selectedWorkloadIds = params.workloads.split(',');

  const selectedWorkloadList = getWorkloads().filter((item) => selectedWorkloadIds.includes(item.id));

  return (
    <table className="table is-bordered is-hoverable is-fullwidth ws-configuration-list">
      {/* <thead>
        <tr>
          <th>Workload</th>
        </tr>
      </thead> */}
      <tbody>
        {
          selectedWorkloadList.map((workloadItem, workloadIndex: number) => {
            return (
              <Fragment key={`ws-workload-${workloadIndex}`}>
                {
                  workloadIndex > 0
                  &&
                  <tr><td><br /></td></tr>
                }
                <tr>
                  <td
                    style={{ position: 'relative', paddingLeft: '32px', fontWeight: 'bold', cursor: 'pointer' }}
                    onClick={() => {
                      let newExpandedIds = [ ...expandedIds ];

                      if (expandedIds.includes(workloadItem.id)) {
                        newExpandedIds = expandedIds.filter(item => item !== workloadItem.id);
                  
                      } else {
                        newExpandedIds.push(workloadItem.id);
                      }
                  
                      setSetExpandedIds(newExpandedIds);
                    }}
                  >
                    {
                      expandedIds.includes(workloadItem.id)
                      ?
                      <Icon iconName={'CollapseContentSingle'} className="ws-deliver-config-collapsed" style={{ verticalAlign: 'top' }} />
                      :
                      <Icon iconName={'ExploreContentSingle'} className="ws-deliver-config-expanded" style={{ verticalAlign: 'top' }} />
                    } {workloadItem.name}
                  </td>
                </tr>
                {
                  expandedIds.includes(workloadItem.id)
                  &&
                  <tr>
                    <td>
                      { props.workloadComponents[workloadItem.id] }
                      {/* <WsConfigHistory
                        tenant={tenant}
                        workload={'entraid'}
                        dataType={dataType}
                        showValues={true}
                        compareTenant={tenants.find((t) => t.azureTenantId === '01903a3d-9408-7684-8552-c2258b002acb')}
                        compareTenantName={compareTenant?.name}
                      /> */}
                    </td>
                  </tr>
                }
              </Fragment>
            );
          })
        }
      </tbody>
    </table>
  );
};




export {
  WsConfigTenant
};
